import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from './global.service';
import { map, catchError } from 'rxjs/operators'
import { environment } from 'src/environments/environment';

const devUrl = environment.backendurl

@Injectable({
  providedIn: 'root'
})
export class CandidateActionService {

  constructor(private http: HttpClient) { }

  //get Candidate Notes  
  getCandidateNotes(data){
    let url = devUrl + "/candidate/getnotes"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Get Candidate Notes', url)))
  }

  //get restricted users of note

  getRestrictedUsersOfNote(data){
    
  let url = devUrl + "/notesrestrictedusers?noteid="+data
  return this.http.get(url).pipe(
    map(response => { return response; })
    , catchError(GlobalService.handleError('Get Single Candidate Call Log', url)))
  }

   //Add Candidate Notes  
 AddCandidateNote(data){
  let url = devUrl + "/candidate/addnotes"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Add Candidate Notes', url)))
}

 //Edit Candidate Notes  
 editCandidateNote(data){
  let url = devUrl + "/candidate/editcandidatenote" 
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Edit Candidate Notes', url)))
}


  //Get Candidate Call Log  
 getCandidateCallLog(data){
  let url = devUrl + "/calllog/getcalllogs"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Edit Candidate Call Logs', url)))
}

  //Edit Candidate Call Log  
  EditCandidateCallLog(data){
    let url = devUrl + "/calllog/editcalllog"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Edit Candidate Call Logs', url)))
  }

 //Crate Candidate Call Log  
 AddCandidateCallLog(data){
  let url = devUrl + "/calllog/createcalllog"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Add Candidate CAll Log', url)))
}


//Get Single Candidate Call Log
getSingleCallLogDetails(callid){
  let url = devUrl + "/getcalllog?calllogid="+callid
  return this.http.get(url).pipe(
    map(response => { return response; })
    , catchError(GlobalService.handleError('Get Single Candidate Call Log', url)))
}

}

 